import PriceBox from './PriceBox';

export default PriceBox;
